import React, { FC, useEffect, useState } from 'react';
import { FormTab, Show, TabbedForm, useShowController } from 'react-admin';
import { Raffle } from '../../types/raffle';
import DreamHomeDescription from './DescriptionDreamHome';
import DiscountAndTickets from '../common/discount/DiscountTickets';
import DreamHomeGeneral from './GeneralDreamHome';
import { GeneralTabErrors } from '../../types/tabsError';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import { Overview } from './shared/overview/OverviewBlock';
import { CreditProps } from '../common/generalPickersBlocks/credits/CreditsPickerComponent';
import { useSelector } from 'react-redux';
import { OverviewProvider } from './shared/overview/OverviewContext';

interface State {
  adress: string;
  isCash: boolean;
  isPercent: boolean;
  isEditedAddress: boolean;
}

const ShowDreamHome: FC = (props) => {
  const controllerProps = useShowController<Raffle>(props);
  const ticketsBundles = useSelector((state) => state.property.ticketsBounds);
  const CustomToolbar = () => {
    return <></>;
  };

  const [isDiscountValidate, setIsDiscountValidate] = useState(false);

  const [overview, setOverview] = useState<Array<Overview>>([]);

  const [datesValue, setDatesValue] = useState<{
    startDateValue: Date | string;
    endDateValue: Date | string;
  }>({
    startDateValue: new Date(),
    endDateValue: new Date('2031-01-18T19:55:00.000+00:00'),
  });
  const [creditDateType, setCreditDateType] = useState<string>('allDate');

  const [errors, setError] = useState({
    imagesError: false,
    discountFillError: false,
  });

  const [stateCredits, setCredits] = useState<Array<CreditProps>>([]);
  const [isActiveCredits, setDoesCreditsActive] = useState<boolean>(false);

  const handleChangeCreditsStatus = () => {
    setDoesCreditsActive(!isActiveCredits);
  };

  const [generalForm, setGeneralForm] = useState({
    titleFill: '',
    startDateFill: '',
    endDateFill: '',
    title: '',
  });

  useEffect(() => {
    if (controllerProps.record) {
      if (controllerProps.record.creditsRates)
        setCredits(controllerProps.record.creditsRates);
      setDoesCreditsActive(controllerProps.record.isCreditsActive);
      setDatesValue({
        startDateValue:
          (controllerProps.record.creditsStartDate &&
            new Date(controllerProps.record.creditsStartDate)) ||
          new Date(),
        endDateValue:
          (controllerProps.record.creditsEndDate &&
            new Date(controllerProps.record.creditsEndDate)) ||
          new Date('2031-01-18T19:55:00.000+00:00'),
      });
      if (
        controllerProps.record.property &&
        controllerProps.record.property.overview
      ) {
        setOverview(controllerProps.record.property.overview);
      }
      if (controllerProps.record.isCreditsPermanent) {
        setCreditDateType('allDate');
      } else {
        setCreditDateType('date');
      }
    }
  }, [controllerProps.record]);

  const fillGeneralForm = (name: string, value: string) => {};

  const [overviewError, setOverviewError] = useState(false);

  const setPercent = () => {
    setState({ ...state, isPercent: false });
  };

  const setCash = () => {
    setState({ ...state, isCash: false });
  };

  const [generalError, setGeneralError] = useState<GeneralTabErrors>({
    imagesError: false,
    titleError: false,
    adressError: false,
    startDateError: false,
    endDateError: false,
  });

  const setAddress = (adress: string) => {
    setState({ ...state, adress: adress, isEditedAddress: true });
  };

  const [state, setState] = useState<State>({
    adress: '',
    isCash: false,
    isPercent: false,
    isEditedAddress: false,
  });
  const set = (adress: string) => {
    setState({ ...state, adress: adress });
  };

  const handleChangeCreditsDateType = (e: any) => {
    setCreditDateType(e.currentTarget.value);
  };

  const handleSetCredits = (creditsArr: Array<CreditProps>) => {
    setCredits(creditsArr);
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setState({ ...state, [event.currentTarget.name]: checked });
  };

  const handleSetDateValue = (value: string, dateName: string) => {
    setDatesValue({
      ...datesValue,
      [dateName]: value,
    });
  };

  return (
    <>
      <DocumentTitle
        core='Prize'
        secondary='Dream Home'
        purpose='Show'
        appointment='dream home'
      />
      <Show {...props} hasEdit={false}>
        <TabbedForm className='general-tab' toolbar={<CustomToolbar />}>
          <FormTab label='General'>
            <DreamHomeGeneral
              latitude={0}
              longitude={0}
              record={undefined}
              isShow={true}
              setAddress={set}
              adress={
                controllerProps.record?.property.location
                  ? controllerProps.record?.property.location
                  : ''
              }
              imagesError={errors.imagesError}
              generalError={generalError}
              fillGeneralForm={fillGeneralForm}
            />
          </FormTab>
          <FormTab label='Description'>
            <OverviewProvider prizeType='dreamhome'>
              <DreamHomeDescription
                key={generalForm.title}
                title={generalForm.title}
                record={controllerProps.record}
                properties={overview}
                setProperties={setOverview}
                setAddress={setAddress}
                isShow={false}
                overviewError={overviewError}
              />
            </OverviewProvider>
          </FormTab>
          <FormTab label='Discount & Tickets'>
            <DiscountAndTickets
              ticketPrice={
                controllerProps.record?.ticketPrice
                  ? controllerProps.record?.ticketPrice
                  : 0
              }
              record={controllerProps.record}
              isShow={true}
              isCash={state.isCash}
              isPercent={state.isPercent}
              isOdds={false}
              entity={controllerProps.record}
              discountSource='property.discountCategory'
              isValidate={isDiscountValidate}
              competition='raffle'
              handleChange={handleChange}
              removePercent={setPercent}
              removeCash={setCash}
              discountFillError={errors.discountFillError}
              handleChangeCreditsStatus={handleChangeCreditsStatus}
              handleChangeCreditsDateType={handleChangeCreditsDateType}
              handleSetCredits={handleSetCredits}
              isActiveCredits={isActiveCredits}
              credits={stateCredits}
              handleSetDateValue={handleSetDateValue}
              creditDateType={creditDateType}
              creditsStartDateValue={datesValue.startDateValue}
              creditsEndDateValue={datesValue.endDateValue}
              freeTicketsRates={controllerProps.record?.freeTicketsRates}
              isFreeTicketsActive={controllerProps.record?.isFreeTicketsRates}
              ticketsBounds={ticketsBundles.ticketsBounds}
            />
          </FormTab>
        </TabbedForm>
      </Show>
    </>
  );
};

export default ShowDreamHome;
